const doorbellAction = (state = "", action) => {
    switch(action.type) {
        case 'doorbellAction':
            return action.payload;
        default:
            return state;
    }
}

export default doorbellAction;